import { gql } from '@apollo/client';

/**
 * GraphQL query for fetching a specific community group by ID
 */
export const GET_COMMUNITY_GROUP = gql`
  query GetCommunityGroup($id: ID!) {
    communityGroup(id: $id) {
      id
      name
      description
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
      topics {
        name
        humanModerationAssignedTtlInSeconds
        maxCasesPerModerator
        humanModerationCasesSlaInSeconds
      }
      actions {
        name
        description
        deliveryType
        labels {
          labelId
          severity
        }
        policies
        operatorName
        deliverySettings {
          url
          postPayload
        }
      }
      workflowConfigurations {
        type
        topicActions {
          topicName
          actionNames
        }
      }
      securityGroups {
        admin
        moderator
        user
      }
      userRole
      roles
    }
  }
`;
